import { Offer } from '@fourthwall/services/dist/models/offer'

type ManufacturerFulfillerPair = {
  fulfiller: Offer.FulfillingService
  manufacturer: Offer.ManufacturingService
}

const VALID_MANUFACTURER_FULFILLER_PAIRS: ManufacturerFulfillerPair[] = [
  ...(
    ['FOURTHWALL_BESPOKE', 'MANUFACTURED_BY_CREATOR', 'DIGITAL_ITEM', 'DEMO_PRODUCT'] as const
  ).flatMap((manufacturer: Offer.ManufacturingService) =>
    Offer.FULFILLING_SERVICES.map((fulfiller) => ({
      fulfiller,
      manufacturer,
    })),
  ),
  { manufacturer: 'SPOKE', fulfiller: 'SPOKE' },
  { manufacturer: 'PRINTFUL', fulfiller: 'PRINTFUL' },
  { manufacturer: 'WLM', fulfiller: 'WLM' },
  { manufacturer: 'DUBOW', fulfiller: 'DUBOW' },
  { manufacturer: 'TRIBE', fulfiller: 'TRIBE' },
  { manufacturer: 'OPTIGER', fulfiller: 'OPTIGER' },
  { manufacturer: 'OVERCAST', fulfiller: 'OVERCAST' },
  { manufacturer: 'REDWALL', fulfiller: 'REDWALL' },
  { manufacturer: 'MWW', fulfiller: 'MWW' },
  { manufacturer: 'P3', fulfiller: 'P3' },
]

export const useManufacturerFulfillerPairs = () => {
  const validateManufacturerFulfillerPair = (value: ManufacturerFulfillerPair) =>
    VALID_MANUFACTURER_FULFILLER_PAIRS.some(
      ({ manufacturer, fulfiller }) =>
        manufacturer === value.manufacturer && fulfiller === value.fulfiller,
    )

  return {
    validateManufacturerFulfillerPair,
  }
}
